import React from 'react';
import classnames from 'classnames';
import { stringifyDateByTimeZone, stringifyUpdatedAtTime } from '../../../helpers/event-time';
import { LiveEventTime } from '../../../state/types';

interface Props {
  title: string;
  createdAt: number;
  startTime: LiveEventTime;
  endTime: LiveEventTime;
  timeZone: string;
  isEmbedded: boolean;
  onEditClick: (_: React.MouseEvent) => void;
}

const EventDescription: React.FC<Props> = ({
  title,
  createdAt,

  startTime,
  endTime,
  timeZone,
  isEmbedded,
  onEditClick
}) => {
  const startTimeText = stringifyDateByTimeZone(startTime, timeZone);
  const endTimeText = stringifyDateByTimeZone(endTime, timeZone);
  const updatedAtText = stringifyUpdatedAtTime(createdAt, timeZone);

  return (
    <div>
      <span className={'event-item-title'} onClick={onEditClick}>
        {title}
      </span>
      <div className={'date-location'}>
        <span className={'event-location'}>{`${startTimeText} - ${endTimeText}`}</span>
      </div>
      {updatedAtText && (
        <div className={'date-location'}>
          <span className={'event-location'}>{`Updated at: ${updatedAtText}`}</span>
        </div>
      )}
      <div className={classnames('event-status', isEmbedded ? 'open' : 'not-embedded')}>
        {isEmbedded ? 'Live updates enabled' : 'Live updates not yet enabled'}
      </div>
    </div>
  );
};

export default EventDescription;
